












































































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent } from '@vue/composition-api';

import NavHeader from '@/components/NavHeader.vue';
import Footer from '@/components/Footer.vue';

export default defineComponent({
  name: "Help",
  components: {
    NavHeader,
    Footer
  },
  head: {
    link: [
      { rel: 'stylesheet', type: 'text/css', href: '/css/sticky-state.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/style.css' },
      { rel: 'stylesheet', type: 'text/css', href: '/css/login/help.css' }
    ],
    script: [
      { src: "https://ajax.googleapis.com/ajax/libs/jquery/1.7/jquery.min.js" },
      { src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/spectrum.min.js" },
      { src: "https://cdnjs.cloudflare.com/ajax/libs/spectrum/1.8.0/i18n/jquery.spectrum-ja.min.js" },
      { src: "/js/sticky-state.min.js" },
      { src: "/js/toggle_contents.js" },
      { src: "/js/help.js" }
    ]
  }
});
